import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface GoalsCompletedTableState {
  data: any;
}

export const GoalsCompletedTable = ({ data }: GoalsCompletedTableState): React.JSX.Element | null => {
  const [goalData, setGoalData] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", width: "300px" },
    { label: "Goal ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "subject.name", width: "200px" },
    { label: "Completed", key: "completed_at_formatted", width: "100px" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      setGoalData(goals as any[]);
    }
  }, [data]);

  return goalData ? <DataTable tableHeadings={tableHeaders} tableData={goalData} title={"Goals Completed"} /> : loadingCard();
};
